import { Alert, breakpoints } from '@toggle/design-system';
import styled from 'styled-components';

export const StyledUploadAlert = styled(Alert)`
  position: fixed;
  z-index: var(--z-index-toast);
  right: 24px;
  top: 24px;

  @media ${breakpoints['max-xs']} {
    left: 50%;
    width: 300px;
    transform: translate(-50%, 0);
  }
`;
